import { useMemo } from "react";
import { useContextMenu } from "@/app/module/index";
import { MenuHookValueType } from "@/app/module/index";

export function useMenu(type: MenuHookValueType) {
  const { menuItems, userMenuItems, footerMenuItems } = useContextMenu();

  return useMemo(() => {
    switch (type) {
      case "main":
        return menuItems;
      case "user":
        return userMenuItems;
      case "footer":
        return footerMenuItems;
      default:
        return [];
    }
  }, [type, menuItems, userMenuItems, footerMenuItems]);
}
